module.exports = __webpack_public_path__ + "img/comment-slash.6668c67b.svg";